import React from "react";
import { Link } from "react-router-dom";

const REASON = { dificuldade_acesso: "Dificuldade de acesso", atendimento_solicitado: "Pediu atendimento",
  informacao_nao_localizada: "Não encontrou a informação", portal_indisponivel: "Portal indisponível" };
const dt = (v) => (v ? new Date(v).toLocaleString("pt-BR") : "—");

export const HandoffQueue = ({ items, onResolve }) => (
  <section className="border border-[#EBE5DF] bg-white p-6 overflow-x-auto" data-testid="wpg-handoffs-section">
    <h2 className="text-lg font-semibold mb-1">Fila de atendimento (administração)</h2>
    <p className="text-xs text-[#5C5A57] mb-4">Acesso, autenticação e dúvidas financeiras não resolvidas. Assuntos comerciais seguem para a revendedora.</p>
    <table className="w-full text-sm" data-testid="wpg-handoffs-table">
      <thead><tr className="text-left text-[11px] uppercase tracking-widest text-[#5C5A57]">
        <th className="py-2">Atualizado</th><th>Cliente</th><th>Telefone</th><th>Empresa</th><th>Motivo</th><th>Contatos</th><th></th>
      </tr></thead>
      <tbody>
        {items.length === 0 && <tr><td colSpan={7} className="py-4 text-[#5C5A57]">Nenhuma pendência aberta.</td></tr>}
        {items.map((h) => (
          <tr key={h.id} className="border-t border-[#EBE5DF]" data-testid={`wpg-handoff-row-${h.id}`}>
            <td className="py-2">{dt(h.updated_at)}</td>
            <td>{h.client_id ? <Link className="underline" to={`/admin/clientes/${h.client_id}`}>{h.client_name}</Link> : "Não identificada"}</td>
            <td>{h.phone_masked || "—"}</td><td>{h.segment || "—"}</td><td>{REASON[h.reason] || h.reason}</td><td>{h.contacts}</td>
            <td><button onClick={() => onResolve(h.id)} className="rounded-full border px-3 py-1 text-xs" data-testid={`wpg-resolve-${h.id}`}>Marcar resolvida</button></td>
          </tr>
        ))}
      </tbody>
    </table>
  </section>
);
